export default __webpack_public_path__ + "static/media/pending-req.d0d12d7e.svg";